import { render, staticRenderFns } from "./product-module.vue?vue&type=template&id=c9ae6f20&scoped=true&"
import script from "./product-module.vue?vue&type=script&lang=js&"
export * from "./product-module.vue?vue&type=script&lang=js&"
import style0 from "./product-module.vue?vue&type=style&index=0&id=c9ae6f20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ae6f20",
  null
  
)

export default component.exports